<script setup lang="ts">
import type { EventCategory } from '../internal/car-presentation.ts'

defineProps<{ category: EventCategory | undefined }>()
</script>

<template>
  <svg
    class="shrink-0"
    viewBox="0 0 16 16"
    width="16"
    height="16"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path
      v-if="category === 'maintenance'"
      d="M10.4 2.6a3 3 0 0 0-3.6 3.9L3 11.3 4.7 13l4.8-3.8a3 3 0 0 0 3.9-3.6l-2 2-2-.5-.5-2z"
    />
    <template v-else-if="category === 'refuelling'">
      <rect x="3" y="2.5" width="6.5" height="11" rx="1" />
      <path d="M9.5 6.5h1.2a1 1 0 0 1 1 1v3a1 1 0 0 0 2 0V5.5l-1.7-1.7" />
    </template>
    <template v-else-if="category === 'parking'">
      <rect x="2.5" y="2.5" width="11" height="11" rx="2" />
      <path d="M6.5 11V5.5h2.3a1.7 1.7 0 0 1 0 3.4H6.5" />
    </template>
    <template v-else-if="category === 'carWash'">
      <path d="M2.8 10.6l1.2-3.3a1.5 1.5 0 0 1 1.4-1h6.2a1.5 1.5 0 0 1 1.4 1l1.2 3.3v2.4H2.8z" />
      <circle cx="5.2" cy="13" r="0.9" />
      <circle cx="10.8" cy="13" r="0.9" />
    </template>
    <path
      v-else-if="category === 'insurance'"
      d="M8 2.2l4.8 1.7v3.8c0 2.8-2 5-4.8 6-2.8-1-4.8-3.2-4.8-6V3.9z"
    />
    <template v-else-if="category === 'other'">
      <path d="M4.2 2.5h5.1l2.5 2.5v8.5H4.2z" />
      <path d="M9.3 2.5V5h2.5M6.3 8.3h3.4M6.3 10.7h3.4" />
    </template>
  </svg>
</template>
